import { useMutation } from '@tanstack/react-query';
import {
  type HandleBatchTaskOptions,
  handleBatchTask,
} from 'shared/api/batches';
import { postDocumentPackage } from '../requests';
import type { PostDocumentPackageRequestType } from '../types';

export const usePostDocumentPackage = (options?: HandleBatchTaskOptions) =>
  useMutation({
    mutationFn: (params: PostDocumentPackageRequestType) =>
      handleBatchTask(postDocumentPackage(params), options),
  });
